import Home from 'pages/blog/page';

const MLBBlogPage = () => <Home sportCategory="mlb" />;
export default MLBBlogPage;
